import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ExprUtils } from '@/common/utils/ExprUtils';

export const AbvPipeDayForm = () => {
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.prodId.expr = ExprUtils.or(
      ExprUtils.whereParams('hierCode', 'PROD_HIER', 'isLeaf', true),
      ExprUtils.whereParams('hierCode', 'PROD_HIER', 'code', 'ADDL_PROD'),
    );

    fieldToFieldDef.channelId.expr = ExprUtils.whereParams('hierCode', 'PIPE_CHANNEL_HIER', 'isLeaf', true);
  };

  return <EntityForm augFieldDefs={augFieldDefs} />;
};
